import React, { useState } from "react";
import { TiArrowDownThick } from "react-icons/ti";
import { Question } from "../../types/Question";
import { CardFeedBeek } from "./CardFeedBeek";

export const FeedBeek = ({ feedBeek }: Props) => {

    const [open, setOpen] = useState<boolean>(false);

    return (
        <>
            <div
                className="flex items-center bg-white border-l-4 border-green-600
                hover:bg-gray-300 justify-between shadow-md 
                border p-2 cursor-pointer rounded-md mb-4"  onClick={() => setOpen((prev) => (prev ? false : true))}
            >
                <div className=" font-bold text-2xl italic">Gabarito</div>
                <div>
                    <TiArrowDownThick
                        className={`${open && "transform rotate-180 "
                            } text-2xl text-green-600 `}

                    />
                </div>
            </div>
            <div className='grid grid-cols-2 gap-6 mb-3'>
                {feedBeek?.map(item => (
                    <div key={item.id}  className={`${open ? "h-max-92 opacity-1" : "h-max-0 h-0 opacity-0"} 
                    transition-all delay-500 duration-300 overflow-hidden`}>
                      <CardFeedBeek feedbeek={item} /> 
                    </div>
                ))}
            </div>
        </>
    );
};

interface Props {
    feedBeek:Question[]
}
